import { useEffect, useRef, type ReactNode } from 'react';
export function Modal({ title, children, onClose, wide = false }: { title: string; children: ReactNode; onClose: () => void; wide?: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const before = document.activeElement as HTMLElement | null;
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    ref.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); onClose(); }
      if (e.key === 'Tab') {
        const focusables = ref.current?.querySelectorAll<HTMLElement>('button:not(:disabled), input, textarea, [tabindex="0"]');
        const first = focusables?.[0], last = focusables?.[focusables.length - 1];
        if (!first || !last) { e.preventDefault(); return; }
        if (e.shiftKey && (document.activeElement === first || document.activeElement === ref.current)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || document.activeElement === ref.current)) { e.preventDefault(); first.focus(); }
      }
    };
    window.addEventListener('keydown', onKey, true);
    return () => { window.removeEventListener('keydown', onKey, true); document.body.style.overflow = original; before?.focus(); };
  }, [onClose]);
  return <div className="dialog-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}><div className={`dialog ${wide ? 'art-dialog' : ''}`} role="dialog" aria-modal="true" aria-label={title} ref={ref} tabIndex={-1}><h2>{title}</h2>{children}</div></div>;
}
